var Features = require("lib/account/Features");
var GradeLevel = require("lib/academic/GradeLevel");
var DropDownOptions = require("components/utility/DropDownOptions");

var StudentMetrics = {
	TYPES: {
		QUIZZES: "quizzes",
		QUIZZES_PASSED: "quizzes-passed",
		QUESTIONS: "questions",
		REVIEWS: "reviews",
		MINUTES: "minutes",
		PAGES: "pages",
		EXERCISES: "exercises",
		QUESTION_BUILDER: "question-builder",
		TEACHERS_PICKS: "teachers-picks",
	},

	QUIZ_OPTIONS: {
		RECALL_QUESTIONS: "recall-questions",
		ANALYSIS_QUESTIONS: "analysis-questions",
		SENTENCE_STARTERS: "sentence-starters"
	},

	QUIZZES_OPTIONS: {
		LAST_QUIZ: "last-quiz",
		QUIZZES: "quizzes",
		QUIZZES_PASSED: "quizzes-passed",
		LAST_QUIZ_DATE: "last-quiz-date",
		LAST_QUIZ_SCORE: "last-quiz-score",
		MEAN_QUIZ_SCORE: "mean-quiz-score",
		QUIZ_PASS_RATE: "quiz-pass-rate",
		ZPD_COUNTS: "zpd-counts",
		ZPD_BELOW: "zpd-below"
	},

	WRITING_OPTIONS: {
		QUESTIONS: "questions",
		REVIEWS: "reviews",
		EXERCISES: "exercises",
		WRITING: "writing",
		QUESTION_BUILDER: "question-builder"
	},

	READING_OPTIONS: {
		MINUTES: "minutes",
		LAST_TEXT: "last-text",
		PAGES: "pages",
		TITLES_READ: "titles-read"
	},

	OTHER_OPTIONS: {
		ACADEMIC_LEVEL: "academic-level",
		TOTAL_READER_LEVEL: "total-reader-level",
		DAYS_ACTIVE: "days-active",
		COINS: "coins",
		TIER: "tier"
	},

	AGGREGATE_OPTIONS: {
		QUIZZES: "quizzes",
		QUIZZES_PASSED: "quizzes-passed",
		MINUTES: "minutes",
		PAGES: "pages",
		COINS: "coins",
		QUESTIONS: "questions",
		REVIEWS: "reviews",
		EXERCISES: "exercises",
	},

	TEACHER_PICKS_SUBJECTS: {
		EXERCISE: 'exercise',
		REVIEW: 'review',
		QUIZ: 'quiz',
		PRACTICE_QUESTION: 'practice question',
		QUESTION_BUILDER: 'meta_cognition'
	},

	OTHER_TYPES: {
		CHALLENGES: "challenges",
		TEACHER_PICKS: "teacher-picks",
	},

	CONFIG: {},

	dashboardColumnMetrics: function() {
		return _.uniq([].concat(
			StudentMetrics.quizMetrics(),
			StudentMetrics.writingMetrics(),
			StudentMetrics.readingMetrics(),
			StudentMetrics.otherMetrics(),
		)).sort();
	},

	aggregateMetrics: function() {
		return _.values(StudentMetrics.AGGREGATE_OPTIONS).sort();
	},

	quizMetrics: function() {
		return _.values(StudentMetrics.QUIZZES_OPTIONS).sort();
	},

	writingMetrics: function() {
		return _.values(StudentMetrics.WRITING_OPTIONS).sort();
	},

	readingMetrics: function() {
		return _.values(StudentMetrics.READING_OPTIONS).sort();
	},

	otherMetrics: function() {
		return _.values(StudentMetrics.OTHER_OPTIONS).sort();
	},

	isMetric: function(key) {
		return key in StudentMetrics.CONFIG;
	},

	getLabel(key) { // Don't add a second arg, since we map to this
		if (key in StudentMetrics.CONFIG) {
			return StudentMetrics.CONFIG[key].label;
		} else {
			return ""
		}
	},
	getOptions(key) {
		return StudentMetrics.CONFIG[key].options;
	},
	getUnit(key) {
		return StudentMetrics.CONFIG[key].unit;
	},

	getType(key) {
		if (StudentMetrics.isMetric(key)) {
			return StudentMetrics.CONFIG[key].type;			
		}
	},

	getAction(key) {
		return StudentMetrics.CONFIG[key].action;
	},
	getActionLabel(key) {
		return StudentMetrics.CONFIG[key].actionLabel;
	},

	getActionButtonText(key) {
		return StudentMetrics.CONFIG[key].buttonText;
	},

	getIcon(key) {
		if (StudentMetrics.CONFIG[key].iconKey) {
			key = StudentMetrics.CONFIG[key].iconKey;
		}
		return dynamicRequire("action-icons/" + key + ".png");
	},

	getValue(digest, key) {
		return digest ? StudentMetrics.CONFIG[key].getValue(digest) : 0;
	},

	getFeatureDependencies(key) {
		return StudentMetrics.CONFIG[key].feature_dependencies;
	},

	getDigestEmbeds(keys) {
		var digestEmbeds = _.map(keys, function(key) {
			return StudentMetrics.CONFIG[key].digestEmbeds;
		});
		return _.flatten(digestEmbeds).join(",")
	},

	inverseLookup(embedKey) {
		return StudentMetrics.INVERSE_LOOKUP[embedKey];
	},
}

StudentMetrics.PRACTICE_EXPECTATION_METRICS = [
	StudentMetrics.TYPES.QUESTIONS,
	StudentMetrics.TYPES.REVIEWS,
	StudentMetrics.TYPES.EXERCISES,
	StudentMetrics.TYPES.MINUTES,
	StudentMetrics.OTHER_OPTIONS.DAYS_ACTIVE,
	StudentMetrics.READING_OPTIONS.PAGES,
	StudentMetrics.TYPES.QUESTION_BUILDER
]

StudentMetrics.QUIZ_EXPECTATION_METRICS = [
	StudentMetrics.TYPES.QUIZZES_PASSED,
	StudentMetrics.QUIZ_OPTIONS.RECALL_QUESTIONS,
	StudentMetrics.QUIZ_OPTIONS.ANALYSIS_QUESTIONS,
	StudentMetrics.QUIZ_OPTIONS.SENTENCE_STARTERS
]

StudentMetrics.CONFIG[StudentMetrics.TYPES.QUIZZES] = {
	label: "Quizzes Taken",
	unit: "quizzes",
	digestEmbeds: ["quiz_count"],
	type: "numeric",
	getValue: function(digest) {
		return digest.quiz_count;
	}
}

StudentMetrics.CONFIG[StudentMetrics.TYPES.TEACHERS_PICKS] = {
	label: "Teachers Picks",
	unit: "teachers-picks",
	digestEmbeds: ["teachers_picks"],
	type: "numeric",
	getValue: function (digest) {
		return digest.teachers_picks;
	},
	action: "quiz",
	actionLabel: "Take a Quiz",
	buttonText: "Take Quiz"
}

StudentMetrics.CONFIG[StudentMetrics.TYPES.QUESTIONS] = {
	label: "Practice Questions",
	unit: "answers",
	digestEmbeds: ["answers_count"],
	type: "numeric",
	getValue: function(digest) {
		return digest.answers_count;
	},
	action: "question",
	actionLabel: "Answer a Question",
	buttonText: "Answer Question"
}

StudentMetrics.CONFIG[StudentMetrics.QUIZ_OPTIONS.RECALL_QUESTIONS] =  {
	label: "Fill-in-the-Blank",
	unit: "questions",
	digestEmbeds: ["recall_question_count"],
	type: "numeric",
	getValue: function(digest) {
		return digest.recall_question_count;
	},
	options: DropDownOptions.Select.RecallQuestionCount()
}

StudentMetrics.CONFIG[StudentMetrics.QUIZ_OPTIONS.ANALYSIS_QUESTIONS] =  {
	label: "Open-Ended",
	unit: "questions",
	digestEmbeds: ["analysis_question_count"],
	type: "numeric",
	getValue: function(digest) {
		return digest.analysis_question_count;
	},
	options: DropDownOptions.Select.AnalysisQuestionCount()
}

StudentMetrics.CONFIG[StudentMetrics.QUIZ_OPTIONS.SENTENCE_STARTERS] =  {
	label: "Sentence Starters",
	unit: "sentence-starter",
	digestEmbeds: ["sentence_starter_count"],
	type: "numeric",
	getValue: function(digest) {
		return digest.sentence_starter_count;
	},
	options: DropDownOptions.Select.SentenceStarter()
}

StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.LAST_QUIZ] = {
	label: "Last Quiz",
	digestEmbeds: ["recent_quiz_text"],
	type: "text",
	getValue: function(digest) {
		if (digest.recent_quiz_text) {
			return digest.recent_quiz_text.title;
		} else {
			return "-";
		}
	}
}

StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.QUIZZES_PASSED] = {
	label: "Quizzes Passed",
	unit: "quizzes",
	digestEmbeds: ["quiz_passed_count"],
	type: "numeric",
	getValue: function(digest) {
		return digest.quiz_passed_count;
	},
	action: "quiz",
	actionLabel: "Take a Quiz",
	buttonText: "Take Quiz"
}

StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.LAST_QUIZ_DATE] = {
	label: "Last Quiz Date",
	digestEmbeds: ["recent_quiz_date"],
	type: "text",
	getValue: function(digest) {
		if (digest.recent_quiz_date) {
			return $wr.momentInTimezone(digest.recent_quiz_date).format("YYYY-MM-DD")
		} else {
			return "-"
		}
	}
}

StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.LAST_QUIZ_SCORE] = {
	label: "Last Quiz Score",
	digestEmbeds: ["recent_quiz_score"],
	type: "text", // To avoid the sum
	getValue: function(digest) {
		if (digest.recent_quiz_score) {
			return digest.recent_quiz_score;
		} else {
			return "-"
		}
	}
}

StudentMetrics.CONFIG[StudentMetrics.WRITING_OPTIONS.REVIEWS] = {
	label: "Reviews",
	unit: "reviews",
	digestEmbeds: ["reviews_count"],
	type: "numeric",
	getValue: function(digest) {
		return digest.reviews_count;
	},
	action: "review",
	actionLabel: "Write a Review",
	buttonText: "Write Review"
}

StudentMetrics.CONFIG[StudentMetrics.READING_OPTIONS.MINUTES] = {
	label: "Minutes",
	unit: "minutes",
	digestEmbeds: ["minutes_read", "verified_minutes_read"],
	type: "numeric",
	feature_dependencies: [Features.LOG_READING],
	getValue: function(digest) {
		return digest.minutes_read;
	},
	action: "log",
	actionLabel: "Log Reading",
	buttonText: "Log Reading"
}

StudentMetrics.CONFIG[StudentMetrics.READING_OPTIONS.PAGES] = {
	label: "Pages",
	unit: "pages",
	digestEmbeds: ["pages_read", "verified_pages_read"],
	type: "numeric",
	feature_dependencies: [Features.LOG_READING],
	getValue: function(digest) {
		return digest.pages_read;
	},
	action: "log",
	iconKey: "minutes",
	actionLabel: "Log Reading",
	buttonText: "Log Reading"
}

StudentMetrics.CONFIG[StudentMetrics.WRITING_OPTIONS.WRITING] = {
	label: "All Writing",
	unit: "writing",
	digestEmbeds: ["writing_count"],
	type: "numeric",
	getValue: function(digest) {
		return digest.writing_count;
	}
}

StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.ZPD_COUNTS] = {
	label: "Quizzes By Level",
	unit: "zpd_counts",
	digestEmbeds: ["zpd_counts"],
	type: "text",
	getValue: function(digest) {
		if (digest.zpd_counts) {
			var value = digest.zpd_counts
			value = "under: " + value.under + "" + " at: " + value.at + "" + " over: " + value.over;
			return value;
		} else {
			return "";
		}
	}
}

StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.ZPD_BELOW] = {
	label: "Quizzes Below Level",
	unit: "zpd_counts",
	digestEmbeds: ["zpd_counts"],
	type: "text",
	getValue: function(digest) {
		if (digest.zpd_counts) {
			var value = digest.zpd_counts;
			var underValue = value.under;
			var total = value.under + value.at + value.over;
			if (total <= 0) {
				return "-";
			}
			return Math.round((underValue / total) * 100) + "%";
		} else {
			return "";
		}
	}
}

StudentMetrics.CONFIG[StudentMetrics.WRITING_OPTIONS.EXERCISES] = {
	label: "Exercises",
	unit: "exercises",
	digestEmbeds: ["responses_count"],
	type: "numeric",
	feature_dependencies: [Features.DIGITAL_EXERCISES],
	getValue: function(digest) {
		return digest.responses_count;
	},
	action: "exercise",
	actionLabel: "Start an Activity",
	buttonText: "Start Exercise"
}

StudentMetrics.CONFIG[StudentMetrics.WRITING_OPTIONS.QUESTION_BUILDER] = {
	label: "Question Builders",
	unit: "question_builder",
	digestEmbeds: ["question_builder_count"],
	type: "numeric",
	getValue: function (digest) {
		return digest.question_builder_count;
	},
	action: "question-builder",
	actionLabel: "Build a Question",
	buttonText: "Build a Question"
}

StudentMetrics.CONFIG[StudentMetrics.READING_OPTIONS.LAST_TEXT] = {
	label: "Currently Reading",
	digestEmbeds: ["recent_text_title"],
	type: "text",
	feature_dependencies: [Features.LOG_READING],
	getValue: function(digest) {
		if (digest.recent_text_title) {
			return digest.recent_text_title;
		} else {
			return "-";
		}
	}
}

StudentMetrics.CONFIG[StudentMetrics.READING_OPTIONS.TITLES_READ] = {
	label: "Titles read",
	digestEmbeds: ["titles_read"],
	type: "numeric",
	unit: "titles read",
	getValue: function(digest) {
		if (digest.titles_read) {
			return digest.titles_read;
		} else {
			return "-";
		}
	}
}

StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.MEAN_QUIZ_SCORE] = {
	label: "Average Quiz Score",
	digestEmbeds: ["mean_quiz_score"],
	type: "text",
	feature_dependencies: [],
	getValue: function(digest) {
		if (digest.mean_quiz_score) {
			return Math.round(digest.mean_quiz_score * 4) / 4;
		} else {
			return "-";
		}
	}
}

StudentMetrics.CONFIG[StudentMetrics.QUIZZES_OPTIONS.QUIZ_PASS_RATE] = {
	label: "Quiz Passing Rate",
	digestEmbeds: ["quiz_pass_rate"],
	type: "text",
	feature_dependencies: [],
	getValue: function(digest) {
		if (digest.quiz_pass_rate != null) {
			return Math.round(digest.quiz_pass_rate * 100) + "%";
		} else {
			return "-";
		}
	}
}

StudentMetrics.CONFIG[StudentMetrics.OTHER_OPTIONS.TOTAL_READER_LEVEL] = {
	label: "Reading Level",
	digestEmbeds: ["total_reader_level", "current_reading_level"],
	type: "text",
	feature_dependencies: [],
	getValue: function(digest) {
		if (digest.total_reader_level) {
			return digest.total_reader_level;
		} else if (digest.current_reading_level) {
			return digest.current_reading_level;
		} else {
			return "-";
		}
	}
}

StudentMetrics.CONFIG[StudentMetrics.OTHER_OPTIONS.COINS] = {
	label: "Coins",
	unit: "coins",
	digestEmbeds: ["coins_count"],
	type: "numeric",
	getValue: function(digest) {
		return digest.coins_count;
	}
}

StudentMetrics.CONFIG[StudentMetrics.OTHER_OPTIONS.DAYS_ACTIVE] = {
	label: "Days Active",
	unit: "days",
	digestEmbeds: ["days_active"],
	type: "numeric",
	getValue: function(digest) {
		return digest.days_active;
	},
	action: "question",
	actionLabel: "Answer a Question",
	buttonText: "Answer Question"
}

StudentMetrics.CONFIG[StudentMetrics.OTHER_OPTIONS.ACADEMIC_LEVEL] = {
	label: "Academic Level",
	digestEmbeds: ["academic_level"],
	type: "text",
	feature_dependencies: [],
	getValue: function(digest) {
		if (digest.academic_level) {
			return GradeLevel.getName(digest.academic_level);
		} else {
			return "-";
		}
	}
}

StudentMetrics.CONFIG[StudentMetrics.OTHER_TYPES.CHALLENGES] = {
	label: "Challenges",
	unit: "challenges",
	getValue: function(digest) {
		return "-";
	},
	buttonText: "Take Challenge"
}

StudentMetrics.CONFIG[StudentMetrics.OTHER_OPTIONS.TIER] = {
	label: "Owl Level",
	unit: "tier",
	digestEmbeds: ["tier"],
	type: "text",
	feature_dependencies: [Features.LOG_READING],
	getValue: function (digest) {
		return digest.tier !== undefined ? String(parseInt(digest.tier) + 1) : "-"
	},
}

StudentMetrics.INVERSE_LOOKUP = {}
_.each(StudentMetrics.CONFIG, (config, metricKey) => {
	_.each(config.digestEmbeds, (embed) => {
		StudentMetrics.INVERSE_LOOKUP[embed] = metricKey;
	})
})

StudentMetrics.DEFAULT_COLUMNS = [
	StudentMetrics.QUIZZES_OPTIONS.LAST_QUIZ,
	StudentMetrics.QUIZZES_OPTIONS.QUIZZES_PASSED,
	StudentMetrics.TYPES.QUESTIONS,
	StudentMetrics.OTHER_OPTIONS.DAYS_ACTIVE
]

module.exports = StudentMetrics;



// WEBPACK FOOTER //
// ./modules/lib/data/StudentMetrics.js